import React, { useCallback, useState, useEffect, useRef } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import { motion, AnimatePresence } from "framer-motion";
import { QRCodeCanvas } from "qrcode.react";
import logo from "../../assets/aitiu.png";
import { ArrowRight, QrCodeIcon } from "lucide-react";
import rodri from "../../assets/rodrigo.jpg";
import {
  FaRocket,
  FaUsers,
  FaCode,
  FaChartLine,
  FaLightbulb,
  FaShieldAlt,
  FaMoneyBillAlt,
  FaMicrochip,
  FaCalculator,
  FaRegLightbulb,
  FaGlobe,
} from "react-icons/fa";
import mockup from "../../assets/mockup.png";
import Marquee from "react-fast-marquee";
import iniflu from "../../assets/iniflu.png";
import cfe from "../../assets/cfe.png";
import refmex from "../../assets/refmex.png";
import sisa from "../../assets/sisa.png";
import itap from "../../assets/itap.png";
import axia from "../../assets/axia.png";
import sparklet from "../../assets/sparklet.png";
import liverpool from "../../assets/liverpool.png";
import fitbody from "../../assets/fitbody.png";
import { useTimer } from "react-timer-hook";
import logo2 from "../../assets/logoAitiu.png";
import hackerIcon from "../../assets/hackerIcon.png";
import { useDispatch, useSelector } from "react-redux";
import { getVotacionesCount } from "../../slices/votacionesSlice";
import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import "@leenguyen/react-flip-clock-countdown/dist/index.css";
import { useNavigate } from "react-router-dom";

const ComingSoon = () => {
  const [showSection2, setShowSection2] = useState(false);
  const [showSection3, setShowSection3] = useState(false);
  const [showSection4, setShowSection4] = useState(false);
  const navigate = useNavigate();
  const [endTime, setEndTime] = useState(new Date(Date.now() + 10000000));
  const [timeLeft, setTimeLeft] = useState(10000000); // Guardamos tiempo restante
  const clockRef = useRef(null); // Creamos una referencia al contador
  const myURL = "https://conexiones.aitiu.com/votar"; // URL que quieres en el QR
  const dispatch = useDispatch();
  const [isAnimating, setIsAnimating] = useState(false);

  const time = new Date();
  time.setSeconds(time.getSeconds() + 300);

  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {}, []);

  const throttle = (func, limit) => {
    let inThrottle;
    return function () {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  };

  const handleScroll = (deltaY) => {
    if (isAnimating) return;

    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 600); // Ajusta según la duración de la animación

    if (deltaY > 0) {
      if (!showSection2) {
        setShowSection2(true);
      } else if (!showSection3) {
        setShowSection3(true);
      } else if (!showSection4) {
        setShowSection4(true);
      }
    } else if (deltaY < 0) {
      if (showSection4) {
        setShowSection4(false);
      } else if (showSection3) {
        setShowSection3(false);
      } else if (showSection2) {
        setShowSection2(false);
      }
    }
  };

  const throttledHandleScroll = throttle((deltaY) => handleScroll(deltaY), 100);

  const [paused, setPaused] = useState(false); // Para controlar si está pausado
  const [restart, setRestart] = useState(false); // Para reiniciar el contador

  const handlePause = () => {
    if (!paused) {
      // Guardamos cuánto tiempo queda
      const remaining = Math.max(0, endTime - Date.now());
      setTimeLeft(remaining);
    } else {
      // Recalculamos endTime con el tiempo restante
      setEndTime(new Date(Date.now() + timeLeft));
    }
    setPaused(!paused);
  };

  const handleRestart = () => {
    setRestart(true); // Reinicia el contador
    setTimeout(() => setRestart(false), 100); // Después de un corto tiempo, restablece el estado de reinicio
  };

  useEffect(() => {
    const handleWheel = (event) => {
      throttledHandleScroll(event.deltaY);
    };

    let touchStartY = 0;
    const THRESHOLD = 50; // Define un umbral para evitar movimientos accidentales

    const handleTouchStart = (event) => {
      touchStartY = event.touches[0].clientY;
    };

    const handleTouchMove = (event) => {
      const touchEndY = event.touches[0].clientY;
      const deltaY = touchStartY - touchEndY;

      if (Math.abs(deltaY) > THRESHOLD) {
        throttledHandleScroll(deltaY);
      }
    };

    window.addEventListener("wheel", handleWheel);
    window.addEventListener("touchstart", handleTouchStart);
    window.addEventListener("touchmove", handleTouchMove);

    return () => {
      window.removeEventListener("wheel", handleWheel);
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchmove", handleTouchMove);
    };
  }, [showSection2, showSection3, showSection4, throttledHandleScroll]);

  const handleComplete = () => {
    navigate("/estadistica");
  };

  const { votacionesCount } = useSelector((state) => state.votaciones);
  const intervalRef = useRef(null);

  useEffect(() => {
    // Ejecutamos inmediatamente la primera vez
    dispatch(getVotacionesCount());

    intervalRef.current = setInterval(() => {
      dispatch(getVotacionesCount()); // Se ejecuta cada 5 segundos
    }, 1000);

    return () => clearInterval(intervalRef.current); // Limpiamos el intervalo al desmontar
  }, [dispatch]); // Se mantiene la dependencia de `dispatch` pero no reinicia el intervalo

  return (
    <div
      className="sm:h-[100vh] h-[100vh]"
      style={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          background: { color: "#000" },
          fpsLimit: 120,
          particles: {
            number: { value: 100 },
            color: { value: ["#FF0000", "#FF7F00"] },
            shape: {
              type: "circle",
            },
            move: {
              enable: true,
              speed: 2,
              direction: "none",
              outMode: "bounce",
              random: true,
              straight: false,
            },
            size: {
              value: { min: 1, max: 3 },
            },
            opacity: {
              value: { min: 0.1, max: 0.5 },
            },
          },
          interactivity: {
            events: {
              onHover: { enable: true, mode: "repulse" },
              onClick: { enable: true, mode: "push" },
            },
          },
        }}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100vh",
          zIndex: -1,
        }}
      />

      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="relative z-10 items-center h-full w-full"
        >
          <div className="relative h-full w-full">
            <motion.div
              className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center text-white text-center font-poppins"
              animate={{ x: showSection2 ? "-100%" : "0%" }}
              transition={{ duration: 0.5 }}
            >
              <img
                className="w-[250px] sm:w-[300px] lg:w-[550px] absolute top-10 sm:top-5"
                src={logo}
                alt="Logo"
              />

              <div className="w-full px-4 sm:px-0 sm:w-[90%] lg:w-[1100px] relative mt-10 sm:mt-32 lg:mt-44">
                <h1 className="text-lg sm:text-3xl lg:text-5xl italic font-semibold">
                  Transformamos ideas en software funcional, porque la
                  innovación es nuestra clave y el código es nuestro lenguaje
                </h1>
              </div>

              <div className="w-full px-4 sm:px-0 sm:w-[90%] lg:w-[1100px] mt-14 sm:mt-16 lg:mt-24">
                <div className="grid grid-cols-2 gap-3 sm:gap-6 lg:gap-8">
                  <div className="card w-full p-3 sm:p-6 border border-white/10 rounded-lg transition-all duration-300 flex flex-col items-center">
                    <FaRocket className="w-6 h-6 sm:w-10 sm:h-10 mb-2 sm:mb-6 text-white" />
                    <h1 className="text-sm sm:text-xl font-semibold mb-1 sm:mb-3">
                      Productos con alcance
                    </h1>
                    <p className="text-[10px] sm:text-sm text-white/70 text-center">
                      Brindamos soluciones para medir el éxito de tu empresa
                    </p>
                  </div>

                  <div className="card w-full p-3 sm:p-6 border border-white/10 rounded-lg transition-all duration-300 flex flex-col items-center">
                    <FaUsers className="w-6 h-6 sm:w-10 sm:h-10 mb-2 sm:mb-6 text-white" />
                    <h1 className="text-sm sm:text-xl font-semibold mb-1 sm:mb-3">
                      Equipos dedicados
                    </h1>
                    <p className="text-[10px] sm:text-sm text-white/70 text-center">
                      Equipo de trabajo enfocado exclusivamente en tu proyecto.
                    </p>
                  </div>

                  <div className="card w-full p-3 sm:p-6 border border-white/10 rounded-lg transition-all duration-300 flex flex-col items-center">
                    <FaCode className="w-6 h-6 sm:w-10 sm:h-10 mb-2 sm:mb-6 text-white" />
                    <h1 className="text-sm sm:text-xl font-semibold mb-1 sm:mb-3">
                      Desarrollo ágil
                    </h1>
                    <p className="text-[10px] sm:text-sm text-white/70 text-center">
                      Aportamos valor durante todo el proceso con metodología
                      scrum.
                    </p>
                  </div>

                  <div className="card w-full p-3 sm:p-6 border border-white/10 rounded-lg bg-transparent  transition-all duration-300 flex flex-col items-center">
                    <FaChartLine className="w-6 h-6 sm:w-10 sm:h-10 mb-2 sm:mb-6 text-white" />
                    <h1 className="text-sm sm:text-xl font-semibold mb-1 sm:mb-3">
                      Estrategia de negocio
                    </h1>
                    <p className="text-[10px] sm:text-sm text-white/70 text-center">
                      Analizamos tus necesidades desde una visión empresarial.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            <AnimatePresence>
              {showSection2 && (
                <motion.div
                  className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center text-white text-center font-poppins"
                  initial={{ x: "100%" }}
                  animate={{ x: showSection3 ? "-100%" : "0%" }}
                  exit={{ x: "100%" }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="sm:flex w-full justify-between font-poppina">
                    <div className=" sm:w-[50%] ">
                      <div>
                        <h1 className="sm:text-6xl text-3xl font-semibold sm:mb-2">
                          Donde nos ubicamos?
                        </h1>
                        <p className="uppercase">
                          Sta. martha 170 , el capullo, cp.45150, zapopan, jal
                        </p>
                      </div>
                      <div className="flex justify-center items-center">
                        <img
                          className="sm:w-[300px] w-[150px] sm:ml-14 sm:mt-5"
                          src={mockup}
                          alt=""
                        />
                        <div className="ml-5">
                          <div className="mb-14 pb-10 border-b sm:mr-0 mr-2 border-b-gray-200 ">
                            <p className="sm:text-7xl text-3xl font-semibold">
                              400 <span>+</span>
                            </p>
                            <p className="sm:text-2xl uppercase">
                              proyectos realizados
                            </p>
                          </div>
                          <div>
                            <p className="sm:text-7xl text-3xl  font-semibold">
                              100%
                            </p>
                            <p className="sm:text-2xl uppercase">
                              ventas a base de reputacion
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="sm:w-[50%] relative sm:mt-0 mt-10 flex items-center justify-center">
                      <h1 className="absolute top-0 sm:text-6xl text-2xl font-semibold ">
                        Clientes
                      </h1>
                      <div className=" max-w-[700px] sm:mt-14 mt-14 overflow-hidden">
                        <Marquee>
                          <img
                            className="sm:w-[250px] w-[100px] mx-4 "
                            src={iniflu}
                            alt=""
                          />
                          <img
                            className="sm:w-[250px] w-[100px] mx-4 "
                            src={cfe}
                            alt=""
                          />
                          <img
                            className="sm:w-[250px] w-[100px] mx-4 "
                            src={refmex}
                            alt=""
                          />
                        </Marquee>
                        <div className="sm:my-16 my-2 ">
                          <Marquee>
                            <img
                              className="sm:w-[250px] w-[100px] mx-4 "
                              src={sisa}
                              alt=""
                            />
                            <img
                              className="sm:w-[250px] w-[100px] mx-4 "
                              src={itap}
                              alt=""
                            />
                            <img
                              className="sm:w-[250px] w-[100px] mx-4 "
                              src={axia}
                              alt=""
                            />
                          </Marquee>
                        </div>
                        <Marquee>
                          <img
                            className="sm:w-[250px] w-[100px] mx-4 "
                            src={sparklet}
                            alt=""
                          />
                          <img
                            className="sm:w-[250px] w-[100px] mx-4 "
                            src={liverpool}
                            alt=""
                          />
                          <img
                            className="sm:w-[250px] w-[100px] mx-4 opacity-50 "
                            src={fitbody}
                            alt=""
                          />
                        </Marquee>
                      </div>
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Tercera sección */}
            <AnimatePresence>
              {showSection3 && (
                <motion.div
                  className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center text-white text-center font-poppins"
                  initial={{ y: "100%" }}
                  animate={{ y: showSection4 ? "-100%" : "0%" }}
                  exit={{ y: "100%" }}
                  transition={{ duration: 0.5 }}
                >
                  <img
                    className="absolute sm:block hidden z-20 top-3 w-20 left-5 "
                    src={logo2}
                    alt=""
                  />
                  <div className="w-full max-w-7xl px-6">
                    <h1 className="sm:text-6xl text-4xl sm:mt-0 mt-3 md:text-9xl font-bold sm:mb-20 ">
                      Rodrigo Silva Bilbao
                    </h1>

                    <div className="flex flex-col md:flex-row items-center justify-center gap-12 mt-12">
                      <div className="relative w-[230px] md:w-[300px]">
                        <img
                          className="w-full h-auto rounded-lg shadow-2xl"
                          src={rodri}
                          alt="Rodrigo Silva Bilbao"
                        />
                        <div className="absolute inset-0 border-2 border-white border-opacity-20 rounded-lg pointer-events-none"></div>
                      </div>

                      <div className="sm:text-left max-w-4xl">
                        <h2 className="text-2xl md:text-5xl font-semibold sm:mb-6 mb-4 text-gray-200">
                          CEO de AITIU & ITYSA | CTO de FITFAM
                        </h2>
                        <p className="text-md md:text-2xl text-gray-300 leading-relaxed mb-8">
                          Ingeniero en Sistemas Computacionales por el
                          Tecnológico de Monterrey, con estudios en blockchain y
                          especialización en ciberseguridad por L'École des
                          Ingénieurs en Intelligence Informatique. Apasionado
                          por la innovación y la transformación digital, con un
                          enfoque en software empresarial, comercio electrónico
                          y automatización de procesos.
                        </p>
                      </div>
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            <AnimatePresence>
  {showSection4 && (
    <motion.div
      className="grid grid-cols-1 sm:grid-cols-2 gap-4 justify-items-center max-w-[90%] mx-auto min-h-screen flex items-center justify-center"
      initial={{ y: "100%" }}
      animate={{ y: "0%" }}
      exit={{ y: "100%" }}
      transition={{ duration: 0.5 }}
    >
      {/* Contador y QR en móviles */}
      <div className="flex sm:hidden flex-col mt-2 items-center justify-center w-full mb-6 space-y-4">
        <QRCodeCanvas
          value={myURL}
          size={128}
          bgColor="#ffffff"
          fgColor="#000000"
        />{" "}
        {/* Reducido el tamaño */}
        <h1 className="text-white text-2xl">
          Votaciones: {votacionesCount}
        </h1>{" "}
        {/* Texto más pequeño */}
        <div className="text-center">
          <div className="scale-25">
            {" "}
            {/* Reducir el tamaño del contador */}
            <FlipClockCountdown
              ref={clockRef} // Referencia al contador
              to={
                paused ? new Date(Date.now() + timeLeft) : endTime
              } // 🔥 Se ajusta dinámicamente
              key={endTime} // 🔥 Esto forza a que el reloj se actualice
              paused={paused} // Estado de pausa
              onComplete={handleComplete}
              digitBlockStyle={{
                width: "30px",
                height: "30px",
                fontSize: "20px",
              }} // Ajusta tamaño
            />
          </div>

          <button
            onClick={handlePause}
            className="text-white px-6 py-2 border rounded-lg mr-4 text-sm"
          >
            {paused ? "Reanudar" : "Pausar"}
          </button>
          <button
            onClick={handleComplete}
            className="text-white text-sm px-6 py-2 border rounded-lg"
          >
            Continuar
          </button>
        </div>
      </div>

      {/* Cards en móviles (2 arriba y 2 abajo) */}
      <div className="sm:hidden w-full">
        {/* Sección de 2 cards arriba */}
        <div className="grid grid-cols-2 gap-4">
          <motion.div
            className="relative border border-opacity-20 w-full h-[150px] flex flex-col justify-center items-center p-4 rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <FaCalculator className="w-10 h-10 mb-2 text-white" />
            <h1 className="text-white text-center text-lg font-semibold mb-2">
              Tips para cotizar un software
            </h1>
          </motion.div>

          <motion.div
            className="relative border border-opacity-20 w-full h-[150px] flex flex-col justify-center items-center p-4 rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <FaRegLightbulb className="w-10 h-10 mb-2 text-white" />
            <h1 className="text-white text-center sm:text-lg font-semibold mb-2">
              Cómo no cagarla emprendiendo en tecnología
            </h1>
          </motion.div>
        </div>

        {/* Sección de 2 cards abajo */}
        <div className="grid grid-cols-2 gap-4 mt-4">
          <motion.div
            className="relative border border-opacity-20 w-full h-[150px] flex flex-col justify-center items-center p-4 rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <FaGlobe className="w-10 h-10 mb-2 text-white" />

            <div className="flex items-center">
              <h1 className="text-white flex text-center text-sm font-semibold">
                La tecnología → Presente → Futuro
              </h1>
            </div>
          </motion.div>

          <motion.div
            className="relative border border-opacity-20 w-full h-[150px] flex flex-col justify-center items-center p-4 rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <img
              src={hackerIcon}
              alt=""
              className="w-10 h-10 mb-2 filter drop-shadow-lg"
            />
            <h1 className="text-white text-center text-lg font-semibold mb-2">
              Hackeo: Mitos y Verdades
            </h1>
          </motion.div>
        </div>
      </div>

      {/* Contador y QR en escritorio */}
      <div className="sm:flex hidden flex-col items-center justify-center sm:absolute sm:top-1/2 sm:left-1/2 sm:transform sm:-translate-x-1/2 sm:-translate-y-1/2">
        <QRCodeCanvas
          value={myURL}
          size={128}
          bgColor="#ffffff"
          fgColor="#000000"
        />
        <h1 className="text-white text-3xl mb-16 font-poppina mt-5">
          Votaciones: {votacionesCount}
        </h1>

        <div className="scale-25">
          {" "}
          {/* Reducir el tamaño del contador */}
          <FlipClockCountdown
            ref={clockRef} // Referencia al contador
            to={paused ? new Date(Date.now() + timeLeft) : endTime} // 🔥 Se ajusta dinámicamente
            key={endTime} // 🔥 Esto forza a que el reloj se actualice
            paused={paused} // Estado de pausa
            onComplete={handleComplete}
            digitBlockStyle={{
              width: "30px",
              height: "50px",
              fontSize: "20px",
            }} // Ajusta tamaño
          />
        </div>

        <div className="text-center flex justify-center items-center gap-4">
          <button
            className="text-white rounded hover:scale-105 transition-all border px-8 py-3 text-sm"
            onClick={handlePause}
          >
            <p className="text-xl">
              {paused ? "Reanudar" : "Pausar"}
            </p>
          </button>
          <button
            onClick={handleComplete}
            className="text-white border hover:scale-105 transition-all rounded px-5 py-3 text-sm"
          >
            <p className="text-xl">Continuar</p>
          </button>
        </div>
      </div>

      {/* Sección 1 y 2 en escritorio */}
      <div className="hidden sm:block section1 w-[45%] h-auto sm:h-screen font-poppina">
        <div className="w-full sm:w-auto h-[50%] flex justify-center items-center">
          <motion.div
            className="relative border border-opacity-20 w-[500px] sm:h-[400px] h-[100px] flex flex-col justify-center items-center p-4 rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <FaCalculator className="sm:w-20 sm:h-20 w-10 h-10 mb-5 text-white" />
            <h1 className="text-white text-center sm:text-4xl text-lg font-semibold mb-4">
              Tips para cotizar un software
            </h1>
            <p className="text-gray-300 sm:block hidden text-center text-base sm:text-lg">
              Aprende a cotizar proyectos de software de manera
              efectiva.
            </p>
          </motion.div>
        </div>

        <div className="w-full sm:w-auto h-[50%] flex justify-center items-center">
          <motion.div
            className="relative border border-opacity-20 w-[500px] sm:h-[400px] h-[100px] flex flex-col justify-center items-center p-4 rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <FaRegLightbulb className="sm:w-20 sm:h-20 w-10 h-10 mb-5 text-white" />
            <h1 className="text-white text-center sm:text-4xl text-lg font-semibold mb-4">
              Cómo no cagarla emprendiendo en tecnología
            </h1>
            <p className="text-gray-300 text-center sm:text-lg sm:block hidden text-sm">
              Consejos clave para evitar errores comunes en el
              emprendimiento tecnológico.
            </p>
          </motion.div>
        </div>
      </div>

      <div className="hidden sm:block section2 w-[45%] h-auto sm:h-screen font-poppina">
        <div className="w-full h-[50%] flex justify-center items-center">
          <motion.div
            className="relative border border-opacity-20 w-[500px] sm:h-[400px] h-[100px] flex flex-col justify-center items-center p-4 rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <FaGlobe className="sm:w-20 sm:h-20 w-10 h-10 mb-5 text-white" />
            <p className="sm:text-3xl block text-white">La tecnología</p>
            <h1 className="text-white text-center sm:text-3xl font-semibold mb-4 flex items-center">
              <div className="sm:flex sm:text-lg items-center block">
                <p className="sm:text-xl">Presente</p>
                <ArrowRight className="mx-1 w-7 sm:block hidden h-7" />
                <p className="sm:text-xl">Futuro</p>
              </div>
            </h1>
            <p className="text-gray-300 text-center sm:block hidden sm:text-lg text-md">
              Explora cómo la tecnología está moldeando el presente
              y el futuro.
            </p>
          </motion.div>
        </div>

        <div className="w-full h-[50%] flex justify-center items-center">
          <motion.div
            className="relative border border-opacity-20 w-[500px] sm:h-[400px] h-[100px] flex flex-col justify-center items-center p-4 rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <img
              src={hackerIcon}
              alt=""
              className="sm:w-24 sm:h-24 w-10 h-10 mb-6 filter drop-shadow-lg"
            />
            <h1 className="text-white text-center sm:text-4xl text-lg font-semibold mb-4">
              Hackeo: Mitos y Verdades
            </h1>
            <p className="text-gray-300 sm:block hidden text-center sm:text-lg text-md">
              Descubre la realidad detrás de los mitos comunes sobre
              el hackeo.
            </p>
          </motion.div>
        </div>
      </div>
    </motion.div>
  )}
</AnimatePresence>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default ComingSoon;
